import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { isAdmin } from 'utils/isAdmin';
const WIDTH = 25;
const radius = '100%';
const fontSize = 20;

export const RingGaugeChart = ({
  value = 55,
  text = 'Average load percentage',
  width = '200px',
}) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  const options = {
    title: {
      text: text, // Tiêu đề biểu đồ
      left: 'center',
      top: '90%',
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        width: '100%',
        overflow: 'break',
        color: isAdminRoute,
      },
    },
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        radius: radius,
        top: '10%',
        progress: {
          show: true,
          width: WIDTH,
        },
        axisLine: {
          lineStyle: {
            width: WIDTH,
            color: [[1, '#D9E5FF']],
          },
        },

        pointer: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        detail: {
          valueAnimation: true,
          formatter: '{value}%',
          color: isAdminRoute,
          fontSize: fontSize,
          offsetCenter: [0, '0%'],
        },
        data: [
          {
            value: value,
          },
        ],
      },
    ],
  };
  return (
    <ReactEcharts
      option={options}
      style={{ width, height: '350px' }}
      onEvents={() => {}}
    />
  );
};
